import moment from 'moment';

import { DATE_FORMAT, MIN_DATE } from '@/consts';

import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  RESET,
} from './types';

export const INIT_STATE = {
  filters: {
    term: '',
    page: 1,
    pageSize: 20,
    fromDate: moment(MIN_DATE).format(DATE_FORMAT),
    toDate: moment().format(DATE_FORMAT),
    hasValueAdjustment: false,
    orderBy: ['matures_on', 'finflux_id']
  },
  items: [],
  total: 0,
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [CLEAR_FILTERS](state) {
    state.filters = { ...INIT_STATE.filters };
  },

  [SET_ITEMS](state, { items, total }) {
    state.items = [...items];
    state.total = total;
  },

  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

};

export default mutations;
